<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CoinChart from "@/components/CoinChart.vue";
import countTo from "vue-count-to";
/**
 * Profile component
 * 
 */

import axios from "axios";
export default {
    components: {Layout,PageHeader, CoinChart, countTo},
     page: {
    title: "Farm",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
    data() {
        return {
            fatcakePrice: null,
            fatcakeChange: null,
            cakePrice: null,
            cakeChange: null,
            title: "Farm",
            items: [{
                    text: "FatCake",
                },
                {
                    text: "Farm",
                    active: true,
                },
            ],
        };
    },
    mounted: function() {
        this.initPage();
    },
    methods: {
        initPage: async function() {
            this.cakePrice = null;
            this.cakeChange = null;

            this.fatcakePrice = null;
            this.fatcakeChange = null;

            let cakeData = await this.getCakeData();
            this.cakePrice = cakeData.price;
            this.cakeChange = cakeData.priceChange;

            let data = await this.getData();
            this.fatcakePrice = data.price;
            let priceChange = data.priceChange;
            this.fatcakeChange = priceChange;
        },
        getData: async function() {
            let result = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=fatcake&vs_currencies=usd&include_market_cap=true&include_24hr_vol=true&include_24hr_change=true");
            return {
                price: result.data.fatcake.usd,
                priceChange: result.data.fatcake.usd_24h_change,
                volume: result.data.fatcake.usd_24h_vol,
            };
        },
        getCakeData: async function() {
            let result = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=pancakeswap-token&vs_currencies=usd&include_24hr_change=true");
            return {
                price: result.data['pancakeswap-token'].usd,
                priceChange: result.data['pancakeswap-token'].usd_24h_change,
            };
        },
    }
};
</script>

<template>
<Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-2">
        <div class="col-xl-4">
            <div class="card h-100">
                <div class="card-body">
                    <div class="text-center">
                        <br/>
                        <div class="clearfix"></div>
                        <div>
                            <img src="https://i.ibb.co/mcp6k1r/Ohne-Titel-27.png" alt class="avatar-lg rounded-circle img-thumbnail" />
                        </div>
                        <h5 class="mt-3 mb-1">CAKE-BUSD Farm</h5>

                        <div class="mt-2">
                            <button type="button" class="btn btn-light btn-sm">
                               2x Multiplier
                            </button>
                        </div>
                    </div>

                    <hr class="my-4" />

                    <div class="text-muted">
                        <h5 class="font-size-16">Farm Contract Address</h5>
                        <p>0x7ddee9691fa6cc2e2827750b258b87c39da045c2</p>
                        <div class="table-responsive mt-4 mb-0">
                            <div>
                                <p class="mb-1">LP Tokens</p>
                                <h5 class="font-size-16">CAKE/BUSD LP</h5>
                            </div>
                            <!-- <div class="mt-4">
                                <p class="mb-1">Mobile :</p>
                                <h5 class="font-size-16">012-234-5678</h5>
                            </div>
                            <div class="mt-4">
                                <p class="mb-1">E-mail :</p>
                                <h5 class="font-size-16">marcus@minible.com</h5>
                            </div>
                            <div class="mt-4">
                                <p class="mb-1">Location :</p>
                                <h5 class="font-size-16">California, United States</h5>
                            </div> -->
                        </div>
                    </div>

                    <br/><br/>

                    <hr style="color: white !important;" />

                    <div class="row">
                        <div class="col-6">
                           <button type="button" class="btn btn-outline-light text-truncate" style="background-color: #e81e63 !important; width: 100% !important;">
                                <i class="uil uil-user me-1"></i> Approve
                            </button>    
                        </div>
                        <div class="col-6">
                           <button type="button" class="btn btn-outline-light text-truncate" style="background-color: #e81e63 !important; width: 100% !important;">
                                <i class="uil uil-envelope-alt me-1"></i> Deposit
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-8">
            <div class="card mb-0 h-100">
                <b-tabs content-class="p-4" justified class="nav-tabs-custom">
                    <b-tab active>
                        <template v-slot:title>
                            <i class="uil uil-clipboard-notes font-size-20"></i>
                            <span class="d-none d-sm-block">Farm Market Data</span>
                        </template>
                        <div>
                            <div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="card" style="background-color: #e81e63 !important;">
                                            <div class="card-body">
                                                <div class="float-end mt-2">
                                                    <img src="https://raw.githubusercontent.com/ApeSwapFinance/apeswap-token-lists/main/assets/CAKE.svg" height="80" alt="">
                                                </div>
                                                <div>
                                                    <h4 class="mb-1 mt-1">
                                                        $
                                                        <span data-plugin="counterup" style="color: white !important;">
                                                            <countTo :startVal="0" :endVal="cakePrice" :duration="2000" :decimals="2"></countTo>
                                                        </span>
                                                    </h4>
                                                    <p class="text-muted mb-0">Cake Price</p>
                                                </div>
                                                <p class="text-muted mt-3 mb-0" v-if="cakeChange">
                                                    <span class="me-1" v-if="cakeChange >= 0">
                                                        <i class="mdi mdi-arrow-up-bold me-1"></i>
                                                        {{ cakeChange.toFixed(2) }} %
                                                    </span>

                                                    <span class="me-1" v-if="cakeChange < 0">
                                                        <i class="mdi mdi-arrow-down-bold me-1"></i>
                                                        {{ cakeChange.toFixed(2) }} %
                                                    </span>
                                                    since last 24h
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="card" style="background-color: #e81e63 !important;">
                                            <div class="card-body">
                                                <div class="float-end mt-2">
                                                    <img src="https://i.ibb.co/ngx3bH1/icon.png" height="80" alt="">
                                                </div>
                                                <div>
                                                    <h4 class="mb-1 mt-1">
                                                        $
                                                        <span data-plugin="counterup" style="color: white !important;">
                                                            <countTo :startVal="0" :endVal="fatcakePrice" :duration="2000" :decimals="8" v-if="fatcakePrice"></countTo>
                                                        </span>
                                                    </h4>
                                                    <p class="text-muted mb-0">FatCake Price</p>
                                                </div>
                                                <p class="text-muted mt-3 mb-0" v-if="fatcakeChange">
                                                    <span class="me-1" v-if="fatcakeChange >= 0">
                                                        <i class="mdi mdi-arrow-up-bold me-1"></i>
                                                        {{ fatcakeChange.toFixed(2) }} %
                                                    </span>

                                                    <span class="me-1" v-if="fatcakeChange < 0">
                                                        <i class="mdi mdi-arrow-down-bold me-1"></i>
                                                        {{ fatcakeChange.toFixed(2) }} %
                                                    </span>
                                                    since last 24h
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <CoinChart 
                                    token="pancakeswap-token"
                                    label="CAKE Price"
                                    color="pink"
                                />
                            </div>

                            <!-- <div>
                                <h5 class="font-size-16 mb-4">Projects</h5>

                                <div class="table-responsive">
                                    <table class="table table-nowrap table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Projects</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Status</th>
                                                <th scope="col" style="width: 120px;">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">01</th>
                                                <td>
                                                    <a href="#" class="text-dark">Brand Logo Design</a>
                                                </td>
                                                <td>18 Jun, 2020</td>
                                                <td>
                                                    <span class="badge bg-soft-primary font-size-12">Open</span>
                                                </td>
                                                <td>
                                                    <b-dropdown right toggle-class="text-muted font-size-18 px-2 p-0" variant="white" menu-class="dropdown-menu-end">
                                                        <template v-slot:button-content>
                                                            <i class="uil uil-ellipsis-v"></i>
                                                        </template>

                                                        <a class="dropdown-item" href="#">Action</a>
                                                        <a class="dropdown-item" href="#">Another action</a>
                                                        <a class="dropdown-item" href="#">Something else here</a>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">02</th>
                                                <td>
                                                    <a href="#" class="text-dark">Minible Admin</a>
                                                </td>
                                                <td>06 Jun, 2020</td>
                                                <td>
                                                    <span class="badge bg-soft-primary font-size-12">Open</span>
                                                </td>
                                                <td>
                                                    <b-dropdown right toggle-class="text-muted font-size-18 px-2 p-0" variant="white" menu-class="dropdown-menu-end">
                                                        <template v-slot:button-content>
                                                            <i class="uil uil-ellipsis-v"></i>
                                                        </template>

                                                        <a class="dropdown-item" href="#">Action</a>
                                                        <a class="dropdown-item" href="#">Another action</a>
                                                        <a class="dropdown-item" href="#">Something else here</a>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">03</th>
                                                <td>
                                                    <a href="#" class="text-dark">Chat app Design</a>
                                                </td>
                                                <td>28 May, 2020</td>
                                                <td>
                                                    <span class="badge bg-soft-success font-size-12">Complete</span>
                                                </td>
                                                <td>
                                                    <b-dropdown right toggle-class="text-muted font-size-18 px-2 p-0" variant="white" menu-class="dropdown-menu-end">
                                                        <template v-slot:button-content>
                                                            <i class="uil uil-ellipsis-v"></i>
                                                        </template>

                                                        <a class="dropdown-item" href="#">Action</a>
                                                        <a class="dropdown-item" href="#">Another action</a>
                                                        <a class="dropdown-item" href="#">Something else here</a>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">04</th>
                                                <td>
                                                    <a href="#" class="text-dark">Minible Landing</a>
                                                </td>
                                                <td>13 May, 2020</td>
                                                <td>
                                                    <span class="badge bg-soft-success font-size-12">Complete</span>
                                                </td>
                                                <td>
                                                    <b-dropdown right toggle-class="text-muted font-size-18 px-2 p-0" variant="white" menu-class="dropdown-menu-end">
                                                        <template v-slot:button-content>
                                                            <i class="uil uil-ellipsis-v"></i>
                                                        </template>

                                                        <a class="dropdown-item" href="#">Action</a>
                                                        <a class="dropdown-item" href="#">Another action</a>
                                                        <a class="dropdown-item" href="#">Something else here</a>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">05</th>
                                                <td>
                                                    <a href="#" class="text-dark">Authentication Pages</a>
                                                </td>
                                                <td>06 May, 2020</td>
                                                <td>
                                                    <span class="badge bg-soft-success font-size-12">Complete</span>
                                                </td>
                                                <td>
                                                    <b-dropdown right toggle-class="text-muted font-size-18 px-2 p-0" variant="white" menu-class="dropdown-menu-end">
                                                        <template v-slot:button-content>
                                                            <i class="uil uil-ellipsis-v"></i>
                                                        </template>

                                                        <a class="dropdown-item" href="#">Action</a>
                                                        <a class="dropdown-item" href="#">Another action</a>
                                                        <a class="dropdown-item" href="#">Something else here</a>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> -->
                        </div>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <i class="uil uil-info-circle font-size-20"></i>
                            <span class="d-none d-sm-block">Farm Information</span>
                        </template>
                        <div>
                            <h5 class="font-size-16 mb-3">Active</h5>

                            <div class="table-responsive">
                                <table class="table table-nowrap table-centered">
                                    <tbody>
                                        <tr>
                                            <td style="width: 60px;">
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-activeCheck2" />
                                                    <label class="custom-control-label" for="tasks-activeCheck2"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Ecommerce Product Detail</a>
                                            </td>

                                            <td>27 May, 2020</td>
                                            <td style="width: 160px;">
                                                <span class="badge bg-soft-primary font-size-12">Active</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-activeCheck1" />
                                                    <label class="custom-control-label" for="tasks-activeCheck1"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Ecommerce Product</a>
                                            </td>

                                            <td>26 May, 2020</td>
                                            <td>
                                                <span class="badge bg-soft-primary font-size-12">Active</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 class="font-size-16 my-3">Farm Information</h5>

                            <div class="table-responsive">
                                <table class="table table-nowrap table-centered">
                                    <tbody>
                                        <tr>
                                            <td style="width: 60px;">
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-upcomingCheck3" />
                                                    <label class="custom-control-label" for="tasks-upcomingCheck3"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Chat app Page</a>
                                            </td>

                                            <td>-</td>
                                            <td style="width: 160px;">
                                                <span class="badge bg-soft-secondary font-size-12">Waiting</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-upcomingCheck2" />
                                                    <label class="custom-control-label" for="tasks-upcomingCheck2"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Email Pages</a>
                                            </td>

                                            <td>04 June, 2020</td>
                                            <td>
                                                <span class="badge bg-soft-primary font-size-12">Approved</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-upcomingCheck1" />
                                                    <label class="custom-control-label" for="tasks-upcomingCheck1"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Contacts Profile Page</a>
                                            </td>

                                            <td>-</td>
                                            <td>
                                                <span class="badge bg-soft-secondary font-size-12">Waiting</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 class="font-size-16 my-3">Complete</h5>

                            <div class="table-responsive">
                                <table class="table table-nowrap table-centered">
                                    <tbody>
                                        <tr>
                                            <td style="width: 60px;">
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-completeCheck3" />
                                                    <label class="custom-control-label" for="tasks-completeCheck3"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">UI Elements</a>
                                            </td>

                                            <td>27 May, 2020</td>
                                            <td style="width: 160px;">
                                                <span class="badge bg-soft-success font-size-12">Complete</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-completeCheck2" />
                                                    <label class="custom-control-label" for="tasks-completeCheck2"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Authentication Pages</a>
                                            </td>

                                            <td>27 May, 2020</td>
                                            <td>
                                                <span class="badge bg-soft-success font-size-12">Complete</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="custom-control custom-checkbox text-center">
                                                    <input type="checkbox" class="custom-control-input" id="tasks-completeCheck1" />
                                                    <label class="custom-control-label" for="tasks-completeCheck1"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a href="#" class="fw-bold text-dark">Admin Layout</a>
                                            </td>

                                            <td>26 May, 2020</td>
                                            <td>
                                                <span class="badge bg-soft-success font-size-12">Complete</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
                <!-- Nav tabs -->
                <!-- Tab content -->
            </div>
        </div>
    </div>
    <!-- end row -->
</Layout>
</template>
